import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserTokenAction: (state, action) => {
      console.log({ action });
      state.user = action.payload?.user;
      state.token = action.payload?.token;
    },
    /* The Hub JWT is short-lived and gets re-minted mid-session. Only the
       token moves — setUserTokenAction would take state.user down with it,
       since it writes both from one payload. */
    setAuthTokenAction: (state, action) => {
      state.token = action.payload || null;
    },
    resetUserTokenAction: (state, action) => {
      state.user = null;
    },
  },
});

export const { setUserTokenAction, setAuthTokenAction, resetUserTokenAction } =
  userSlice.actions;
export default userSlice.reducer;
